const BLACKLISTED_DOMAINS = new Set(['hotmail', 'outlook', 'microsoft', 'linkedin', 'aol', 'xing', 'hubspot', 'hubteamqa.com', 'google', 'yahoo', 'gmail', 'facebook', 'twitter.com', 'about.me', 'linkedin.com']);
export const isTestingOrInternalEmailDomain = domain => {
  return ['hubspot.com', 'hubspotemail.net', 'hubspotemailqa.com'].includes(domain);
};
export const matchesBlacklist = domain => {
  const lowerCaseDomain = domain.toLowerCase();
  return BLACKLISTED_DOMAINS.has(lowerCaseDomain.split('.')[0]);
};
export const getDomainFromEmail = (userEmail, includeBlacklisted = false) => {
  if (!userEmail) {
    return '';
  }

  const domain = userEmail.split('@')[1];

  if (!domain || !includeBlacklisted && matchesBlacklist(domain)) {
    return '';
  }

  return domain;
};